
import reviewerTypeList from "./time-period/reviewer-type";

export default [...reviewerTypeList];